import { 
  FaFacebook, 
  FaInstagram, 
  FaLinkedinIn, 
  FaWhatsapp,
  FaEnvelope,
  FaTimes
} from "react-icons/fa";
import { useState } from 'react';
import SocialQRCode from './SocialQRCode';

const socialLinks = [
  {
    name: 'Facebook',
    url: 'https://www.facebook.com/hadritech.consultoria/',
    icon: <FaFacebook className="w-5 h-5" />,
    color: 'hover:bg-[#1877F2]',
    bgColor: 'bg-[#1877F2]',
  },
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/hadritech.consultoria/',
    icon: <FaInstagram className="w-5 h-5" />,
    color: 'hover:bg-gradient-to-r from-[#F58529] via-[#DD2A7B] to-[#8134AF]',
    bgColor: 'bg-gradient-to-r from-[#F58529] via-[#DD2A7B] to-[#8134AF]',
  },
  {
    name: 'LinkedIn',
    url: 'https://www.linkedin.com/company/hadritech-oficial/',
    icon: <FaLinkedinIn className="w-5 h-5" />,
    color: 'hover:bg-[#0A66C2]',
    bgColor: 'bg-[#0A66C2]',
  },
  {
    name: 'WhatsApp',
    url: 'https://wa.me/5511954938127',
    icon: <FaWhatsapp className="w-5 h-5" />,
    color: 'hover:bg-[#25D366]',
    bgColor: 'bg-[#25D366]',
  },
  {
    name: 'E-mail',
    url: 'mailto:contato@hadritech.com.br',
    icon: <FaEnvelope className="w-5 h-5" />,
    color: 'hover:bg-gray-700',
    bgColor: 'bg-gray-700',
  },
];

const SocialLinks = () => {
  const [showQRCode, setShowQRCode] = useState(false);

  return (
    <div className="relative">
      <div className="grid grid-cols-3 gap-4">
        {socialLinks.map((link, index) => (
          <a
            key={index}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className={`flex flex-col items-center justify-center p-4 rounded-lg transition-all duration-300 transform hover:scale-105 hover:shadow-lg ${link.color} text-white`}
            aria-label={link.name}
          >
            {link.icon}
            <span className="mt-2 text-sm font-medium">{link.name}</span>
          </a>
        ))}
        

      </div>
      
      {showQRCode && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl p-6 max-w-sm w-full relative">
            <button 
              onClick={() => setShowQRCode(false)}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
              aria-label="Fechar"
            >
              <FaTimes className="w-6 h-6" />
            </button>
            <SocialQRCode />
          </div>
        </div>
      )}
    </div>
  );
};

export default SocialLinks;
